// extracted by mini-css-extract-plugin
export default {"imageWrapper":"imageWrapper__si0Nc","overlay":"overlay__W9vIS"};